import CheckoutMap from './checkout-map';

'use strict';

class ChooseYourZone {
  constructor(elem) {
    this.target = elem;
    this.stepWrapper = this.target.closest('[data-step-toggle-active]');
    this.stepsWrapper = this.target.closest('[data-accommodation-active-step]');
    this.contentAccommodation = this.stepWrapper.querySelector('[data-content-zone]');
    this.buttonClose = this.stepWrapper.querySelector('[data-close-zone]');
    this.clickClose = this.close.bind(this);
    this.events();
  }

  open() {
    this.target.classList.add('active');
    this.contentAccommodation.classList.remove('active');

    const checkoutZonesMap = this.target.querySelector('.js-checkout-zones-map');
    if (checkoutZonesMap && !checkoutZonesMap.checkoutZonesMap) {
      checkoutZonesMap.checkoutZonesMap = new CheckoutMap(checkoutZonesMap);
    } else {
      checkoutZonesMap.checkoutZonesMap.updateMap();
    }
    this.stepWrapper.scrollIntoView();
  }

  close() {
    this.target.classList.remove('active');
    this.contentAccommodation.classList.add('active');
    document.dispatchEvent(new CustomEvent('choose-your-zones-closed'));
  }

  events() {
    if (this.buttonClose) {
      this.buttonClose.removeEventListener('click', this.clickClose);
      this.buttonClose.addEventListener('click', this.clickClose);
    }

    this.target.querySelector('.js-checkout-zones-map').addEventListener('open-zone-click', (e) => {
      const buttonOpen = this.stepWrapper.querySelector('[data-open-zone]');

      if (buttonOpen) {
        this.open();
      }
    }, false);

    document.addEventListener('editStep', (e) => {
      this.close();
    }, false);
  }
}

const chooseYourZone = document.querySelector('[data-target-zone]');
if (chooseYourZone) {
  chooseYourZone.cyz = new ChooseYourZone(chooseYourZone);
}
